import { accessibleHover } from '@helpers/accessibleHover';
import animation from '@helpers/animation';
import brand from '@helpers/brand';
import styled, { css } from 'styled-components';
import { ScrollToTopTheme } from './ScrollToTop.hybrid';

const Wrapper = styled.div<{ visible: boolean; themeOption: ScrollToTopTheme }>`
  position: fixed;
  color: ${brand.white};
  font-size: 30px;
  height: 50px;
  padding: 10px;
  width: 50px;
  opacity: 1;
  transition: transform 0.5s ${animation.easeInOutCubic}, opacity 0.5s ${animation.easeInOutCubic},
    background-color 0.2s ${animation.easeInOutCubic};

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 998;
  cursor: pointer;

  ${({ themeOption }) => {
    switch (themeOption) {
      case ScrollToTopTheme.ROUNDED_RED:
        return css`
          background-color: ${brand.red.base};
          padding-top: 6px;
          border-radius: 50%;
          box-shadow: 0px 2px 6px rgba(0 0 0 / 15%);
          bottom: 12px;
          right: 12px;

          ${accessibleHover(css`
            background-color: ${brand.red.dark};
          `)}
        `;

      case ScrollToTopTheme.DEFAULT:
      default:
        return css`
          bottom: 0px;
          right: 0px;
          background-color: ${brand.grey[15]};

          ${accessibleHover(css`
            background-color: ${brand.black};
          `)}
        `;
    }
  }}

  ${({ visible }) =>
    visible
      ? css`
          transform: translateX(0%);
          opacity: 1;
        `
      : css`
          transform: translateX(100%);
          opacity: 0;
          pointer-events: none;
        `};

  svg {
    width: 25px;
    height: 25px;
  }
`;

const ScrollToTopStyles = {
  Wrapper,
};

export default ScrollToTopStyles;
